// extracted by mini-css-extract-plugin
module.exports = {"logo_contact":"logoContact__logo_contact__3ESpn"};